

import { ErrorMessage, useField } from 'formik';

import * as React from 'react';

import {TextField, Box} from '@mui/material/';




export const NewTextField = ({label, ...props}) => {
  const [field, meta] = useField(props);
  //console.log(field,meta);
  return (
    <Box
      sx={{
        width: '100%',
        paddingTop: '10px',
        paddingBottom: '20px',
        maxWidth: '100%',
      }}
    >
      <TextField fullWidth label={label}
      className={`form-control shadow-none ${meta.touched && meta.error && 'is-invalid'}`}
      {...field} {...props}
      autoComplete='off'
      />
      <ErrorMessage component="div" name={field.name} className="error" />
    </Box>
  );

}


